export class User {
  id: number;
  name: string;
  cSID:number;
  roleId:number;
  password: string;
  status: string;
  role:string;
  lastLoggedIn: string;
  lastLoggedInDevice: string;
  lastDevice:string;
  lastSynch: string;
  redlinings: number;
  schemaName:string;
  lock: number;
  domain:string;
}

export class UserResolved {
  user: User;
  error?: any;
}
